<template>
  <div>
    <h2 v-if="label" class="nx-form-legend">{{ label }}</h2>
    <nx-navigation-editor
      :data-vv-name="name"
      :data-vv-scope="scope"
      :data-vv-as="label"
      v-validate
      :value="value"
      @input="onInput"
      data-vv-value-path="value"
      v-bind="$attrs"
    ></nx-navigation-editor>
  </div>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import NavigationEditor from '@/modules/navigation/NavigationEditor';

export default {
  name: 'nx-navigation-form-editor',
  mixins: [FormElement],
  components: {
    [NavigationEditor.name]: NavigationEditor,
  },
  props: {
    label: {
      type: String,
    },
    value: {
      type: Array,
    },
  },
  methods: {
    onInput(value) {
      this.$parentForm.updateField(this.name, value);
      this.$emit('input', value);
    },
  },
};
</script>
